const selectors = {
  page: {
    main: '[data-main]',
    body: '[data-body]',
    cartCounter: '[data-cart-counter]',
    overlayMain: '[data-overlay-main]',
    freeShippingBar: '[data-free-shipping-bar]',
    plantQuizEmbed: '[data-lr-embed-quiz]',
  },
  product: {
    el: '[data-product]',
    form: {
      el: '[data-product-form]',
      variants: '[data-variants]',
      productOption: '[data-product-option]',
      quantity: '[data-quantity]',
      atc: '[data-product-form-atc]',
      submit: '[data-product-submit]',
      submitText: '[data-product-text]',
      atcType: '[data-atc-type]',
    },
    item: {
      el: '[data-product-item]',
      urlAttr: 'data-product-item-url',
      idAttr: 'data-product-item-id',
      figure: '[data-product-item-figure]',
    },
    addon: {
      data: '[data-addon-data]',
      error: '[data-addon-error]',
      errorAttr: 'data-addon-error',
      contents: '[data-product-addon]',
      selectorAttr: 'data-product-item-addon',
    },
    atc: '[data-product-atc]',
    addonAtc: '[data-product-addon-atc]',
    variantMetafields: '[data-product-variant-lr-metafields]',
    datePicker: '[data-date-picker]',
    embed: '[data-lr-embed-product]',
  },
  quantity: {
    el: '[data-quantity]',
    submitEl: '[data-quantity-submit]',
    decrement: '[data-quantity-decrement]',
    increment: '[data-quantity-increment]',
    element: '[data-quantity-element]',
    input: '[data-quantity-input]',
  },
  cart: {
    el: '[data-cart]',
    form: '[data-cart-form]',
    expand: '[data-cart-expand]',
    toggle: '[data-cart-toggle]',
    expandable: '[data-cart-expandable]',
    totals: '[data-cart-totals]',
    subtotal: '[data-cart-subtotal]',
    submit: '[data-cart-submit]',
    checkoutButton: '[data-cart-checkout-button]',
    otherItemsButton: '[data-cart-other-items-button]',
    atcSuccess: '[data-product-atc-success]',
    attribute: '[data-cart-attribute]',
    disableEls: '[data-cart-disable]',
    contents: '[data-cart-contents]',
    overlay: '[data-cart-overlay]',
    items: '[data-cart-items]',
    item: {
      el: '[data-cart-item]',
      data: '[data-cart-item-data]',
      remove: '[data-cart-item-remove]',
      price: '[data-cart-item-price]',
      total: '[data-cart-item-total]',
      slide: '[data-cart-item-column-slide]',
      plus: '[data-cart-item-plus]',
      minus: '[data-cart-item-minus]',
      quantity: '[data-cart-item-quantity]',
      stockNotice: '[data-stock-notice]',
      oosNotice: '[data-oos-notice]',
      totals: '[data-cart-item-totals]',
      property: {
        el: '[data-cart-item-property]',
      },
    },
    note: '[data-cart-note]',
    gift: '[data-cart-gift]',
    addon: {
      item: '[data-cart-item-addon]',
      button: '[data-cart-item-addon-button]',
    },
  },
  price: {
    compareAt: '[data-price-compare-at]',
    price: '[data-price]',
    discount: '[data-discount]',
  },
  expandable: {
    cartItem: '[data-cart-expandable]',
    item: '[data-expandable]',
    trigger: '[data-expand-trigger]',
    header: '[data-expand-header]',
    body: '[data-expand-body]',
  },
  modal: {
    el: '[data-modal]',
  },
  search: {
    input: '[data-search-bar]',
    clear: '[data-search-clear]',
  },
  searchable: {
    el: '[data-searchable]',
  },
  popover: {
    el: '[data-popover]',
    text: '[data-popover-text]',
    trigger: '[data-popover-trigger]',
  },
  readMore: {
    el: '[data-read-more]',
    trigger: '[data-read-more-trigger]',
  },
  slider: {
    el: '[data-slider]',
    parentSlider: '[data-slider-parent]',
    slides: '[data-slides]',
    sliderThumbnails: 'data-slider-thumbnails',
    options: 'data-slider-options',
    thumbnails: 'data-thumbnails',
    thumbnailsOptions: 'data-thumbnails-options',
    thumbnailsIndex: 'data-thumbnail-index',
  },
  keenSlider: {
    el: '[data-keen-slider]',
    overlay: '[data-keen-slider-overlay]',
    sliderID: '[data-keen-slider-id]',
    slide: '[data-keen-slide]',
    options: '[data-keen-slider-options]',
    thumbnails: '[data-fancybox]',
  },
};

const classes = {
  scrollLock: {
    locked: 'scroll-lock',
  },
  states: {
    show: 'show',
    hide: 'hide',
  },
  elements: {
    overlay: 'overlay',
  },
  drawerToggles: {
    active: 'has-active-toggle',
    disabled: 'is-disabled-toggle',
  },
  popover: {
    created: 'popover-created',
    listItemActive: 'popover-list-item-active',
    scrolls: 'popover-scrolls',
    active: 'popover-active',
    hideHeader: 'popover-hides-header',
    buttonActive: 'popover-button-active',
    buttonHidden: 'popover-button-hidden',
  },
  product: {
    slideshowImageSelected: 'product-slideshow-image-selected',
    slideshowThumbnailSelected: 'product-slideshow-thumbnail-selected',
    slideshowThumbnailsFlickityEnabled: 'product-slideshow-thumbnails-flickity-enabled',
    quickshop: {
      wrapper: 'product-item-quickshop',
      error: 'quickshop-form-errors',
    },
    addon: {
      wrapper: 'product-addon-wrapper',
      error: 'addon-form-errors',
    },
    atc: {
      static: 'product-atc-static',
      defaultVariant: 'product-atc-defaultvariant',
      popper: 'product-atc-popper',
      formActive: 'product-atc-popper-form-active',
      cartActive: 'product-atc-popper-cart-active',
      loading: 'product-form-atc-loading',
    },
  },
  cart: {
    inline: 'cart-inline',
    drawer: 'cart-drawer',
    mini: 'cart-mini',
    emptying: 'cart-emptying',
    empty: 'cart-empty',
    loading: 'cart-loading',
    loadingAffectsTotal: 'cart-loading-affects-total',
    reloading: 'cart-reloading',
    expanded: 'cart-expanded',
    itemList: 'cart__item-list',
    item: {
      inlineVisible: 'cart-inline-visible',
      inlineRecentlyAdded: 'cart-inline-recentlyadded',
      loading: 'cart-item-loading',
      totalLoading: 'cart-item-total-loading',
      sliding: 'cart-item-sliding',
    },
    expandable: {
      expanded: 'cart-expand-button-expanded',
    },
  },
  quantity: {
    disabled: 'form-element-disabled',
  },
};

const events = {
  window: {
    scrolled: 'scrolled',
  },
  cart: {
    error: 'cart-error',
    reloadStart: 'cart-reload-start',
    reloadFinish: 'cart-reload-finish',
    loadingStart: 'cart-loading-start',
    didUpdate: 'cart-did-update',
    loadingFinish: 'cart-loading-finish',
    inlineVisible: 'cart-inline-visible',
    open: 'cart-drawer-open',
    close: 'cart-drawer-close',
    item: {
      loadingStart: 'cart-item-loading-start',
      loadingFinish: 'cart-item-loading-finish',
      removingFinished: 'cart-item-removing-finished',
    },
    note: {
      loadingStart: 'cart-note-loading-start',
      loadingFinish: 'cart-note-loading-finish',
    },
    attributes: {
      loadingStart: 'cart-attributes-loading-start',
      loadingFinish: 'cart-attributes-loading-finish',
    },
    addon: {
      loadingStart: 'cart-addon-loading-start',
      loadingFinish: 'cart-addon-loading-finish',
    },
  },
  cartjs: {
    ready: 'cart.ready',
    requestStarted: 'cart.requestStarted',
    requestComplete: 'cart.requestComplete',
  },
  overlay: {
    show: 'overlay-show',
    hide: 'overlay-hide',
  },
  search: {
    didSearch: 'did-search',
    didClear: 'did-clear',
  },
};
const variables = {
  mobileBreakpoint: 1024,
};
export {
  classes,
  selectors,
  events,
  variables,
};
